export default "__VITE_ASSET__HBTBDbE6__"